import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getPreShopsData = params =>
  axios.get(`${API_HOST}/preShops`, { params, withCredentials: true });

export const downloadPreShopData = params =>
  axios.post(`${API_HOST}/preShops/download`, params, {
    withCredentials: true
  });

export const getPreShopDetailData = (preShopId, params) =>
  axios.get(`${API_HOST}/preShops/${preShopId}`, {
    params,
    withCredentials: true
  });

export const editPreShopData = (preShopId, params) =>
  axios.put(`${API_HOST}/preShops/${preShopId}`, params, {
    withCredentials: true
  });
